// Module
var code = "<div> </div> ";
// Exports
var _module_exports = code;;
var path = 'app/common/ui/breadcrumb/templates/breadcrumb.navigator.tpl.html';
window.angular.module('app').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;